@if (step() === 'intro') {
  <section mat-dialog-title>
    <span>Turn on 2FA</span>
    <button mat-dialog-close>
      <i class="icon-close"></i>
    </button>
  </section>
  <mat-dialog-content>
    <p>Start by getting the Authenticator app. On your phone, install the Microsoft Authenticator or Google Authenticator app. After you install the Authenticator app on your device, choose "Next".</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      class="btn-transparent btn-medium font-bold mr-4"
      mat-dialog-close
    >
      CANCEL
    </button>
    <button
      class="btn-green btn-medium font-bold"
      (click)="next()"
    >
      NEXT
    </button>
  </mat-dialog-actions>
}

@if (step() === 'scan') {
  <section mat-dialog-title>
    <span>Scan the QR code</span>
    <button mat-dialog-close>
      <i class="icon-close"></i>
    </button>
  </section>
  <mat-dialog-content>
    <div class="flex gap-4 max-sm:flex-col-reverse">
      <div>
        @if (qrCodeDataUrl(); as qrCodeDataUrl) {
          <img
            [src]="qrCodeDataUrl"
            alt="Two-factor authentication QR code"
            height="160"
            width="160"
          />
        } @else {
          <div class="flex items-center justify-center w-[160px] h-[160px]">
            <mat-spinner diameter="32"></mat-spinner>
          </div>
        }
      </div>
      <div class="flex-1 mt-2">
        <p class="mb-4">Use the app to scan the QR code. This will connect the Authenticator to your account.</p>
        <p class="mb-1">Can't scan the code? Enter this key manually:</p>
        <p class="font-bold select-all break-all">{{ store.secret() }}</p>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      class="btn-transparent btn-medium font-bold mr-4"
      (click)="back()"
    >
      BACK
    </button>
    <button
      class="btn-green btn-medium font-bold"
      (click)="next()"
    >
      NEXT
    </button>
  </mat-dialog-actions>
}

@if (step() === 'code') {
  <section mat-dialog-title>
    <span>Enter your code</span>
    <button mat-dialog-close>
      <i class="icon-close"></i>
    </button>
  </section>
  <mat-dialog-content>
    <p class="mb-4">Enter the 6-digit code from your authenticator app.</p>
    <avs-totp-code (valueChange)="onTokenChange($event)" />
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      class="btn-transparent btn-medium font-bold mr-4"
      (click)="back()"
    >
      BACK
    </button>
    <button
      class="btn-green btn-medium font-bold"
      (click)="verify()"
      [disabled]="!isCodeComplete() || store.isPending()"
    >
      @if (store.isPending()) {
        <mat-spinner
          class="mr-1"
          diameter="20"
        ></mat-spinner>
      }
      VERIFY
    </button>
  </mat-dialog-actions>
}

@if (step() === 'recovery-codes') {
  <section mat-dialog-title>
    <span>Save your recovery codes</span>
  </section>
  <mat-dialog-content>
    <p class="mb-4">Use these codes to sign in if you lose access to your authenticator app. Save them now — you won't see them again.</p>
    <ul class="font-mono">
      @for (code of store.recoveryCodes(); track code) {
        <li>{{ code }}</li>
      }
    </ul>
    <div class="flex justify-between mt-4">
      <div class="flex items-center">
        <span class="font-bold">Copy all codes</span>
        <avs-copy [value]="store.recoveryCodes()?.join('\n') || ''" />
      </div>

      <mat-checkbox
        class="-ml-2.5"
        (ngModelChange)="hasSavedRecoveryCodes.set($event)"
        [ngModel]="hasSavedRecoveryCodes()"
      >
        I've saved these codes
      </mat-checkbox>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      class="btn-green btn-medium font-bold"
      (click)="done()"
      [disabled]="!hasSavedRecoveryCodes()"
    >
      DONE
    </button>
  </mat-dialog-actions>
}
